var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ErrorLayout',[_c('p',[_vm._v("エラーコード："+_vm._s(_vm.errorCode))]),_c('p',[_vm._v("エラーが発生しました。詳細確認させていただきますので、下記フォームより上記エラーコードと必要事項入力の上お問い合わせください。")]),_c('a',{attrs:{"href":_vm.loginErrorForm}},[_vm._v(_vm._s(_vm.loginErrorForm))])])
}
var staticRenderFns = []

export { render, staticRenderFns }